import { SidebarItem } from '@backstage/core-components';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

export function ServiceCatalogAuditSidebarItem() {
  return (
    <SidebarItem
      icon={AssignmentTurnedInIcon}
      to="service-catalog-audit"
      text="Audit [Service Catalog]"
    />
  );
}
